export default __webpack_public_path__ + "static/media/add-watchlist.ac3d69f4.svg";